import { IssueTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';
import { LinkedDocumentationDescriptionKind } from 'shared/domain/issue/linkedDocumentation/types';

const LINKED_DOCUMENTATION_DESCRIPTION_LABEL_KEYS: Record<LinkedDocumentationDescriptionKind, TranslationKey> = {
  [LinkedDocumentationDescriptionKind.currentVersionOfDocumentation]:
    IssueTranslationKeys.linkedDocumentationCaptionCurrentVersion,
  [LinkedDocumentationDescriptionKind.documentationWithoutCurrentVersion]:
    IssueTranslationKeys.linkedDocumentationCaptionNoCurrentVersion,
  [LinkedDocumentationDescriptionKind.version]: IssueTranslationKeys.linkedDocumentationCaptionVersion,
};

/** What a linked documentation shows, as its tile tells it (PT-7117); takes `{version}` and `{state}`. */
export function linkedDocumentationDescriptionLabelKey(kind: LinkedDocumentationDescriptionKind): TranslationKey {
  return LINKED_DOCUMENTATION_DESCRIPTION_LABEL_KEYS[kind];
}

/** The outdated linked version's warning in its preview (PT-7117); takes `{version}`: the current one. */
export function outdatedLinkedVersionNoticeKey(hasCurrentVersion: boolean): TranslationKey {
  if (hasCurrentVersion) {
    return IssueTranslationKeys.linkedDocumentationOutdatedVersionNotice;
  }
  return IssueTranslationKeys.linkedDocumentationOutdatedVersionNoticeWithoutCurrent;
}
